export const fillPlaceholders = (
  text: string = '',
  replacements: { [key: string]: string },
  startTag = '@@',
  endTag = '@@',
): string => {
  let tx = text;
  Object.keys(replacements).forEach((key) => {
    tx = tx.replace(startTag + key + endTag, replacements[key]);
  });
  return tx;
};

export const isStringsPropOk = (
  stringsKeys: readonly string[],
  strings: { [p: string]: string },
  componentName: string,
) => {
  let notIncludedString;

  const isStringKeyIncluded = (currentValue: string) => {
    const isKeyIncluded = Object.keys(strings).includes(currentValue);

    if (!isKeyIncluded) notIncludedString = currentValue;

    return isKeyIncluded;
  };

  const allStringsProvided = stringsKeys.every(isStringKeyIncluded);

  if (!allStringsProvided) {
    throw new Error(
      `Property '${notIncludedString}' is missing, but is required in strings Object in ${componentName} component.`,
    );
  }
};
